export class ItemOfferInputDto {
    promotionCode = '';
    productId = 0;
    quantity = 0;
}